
type UserStatus = 'active' | 'inactive' | 'suspended' | 'banned' | undefined;
import {
    Users, Ban, CheckCircle, XCircle, Clock, User,
    Shield,
    AlertTriangle,
} from 'lucide-react';
export const getUserStatusIcon = (status: UserStatus): JSX.Element => {
    switch (status) {
        case 'active':
            return <CheckCircle className="w-4 h-4" />;
        case 'inactive':
            return <Clock className="w-4 h-4" />;
        case 'suspended':
            return <Ban className="w-4 h-4" />;
        case 'banned':
            return <XCircle className="w-4 h-4" />;
        default:
            return <User className="w-4 h-4" />;
    }
};

export const getUserTypeIcon = (userType: string | undefined) => {
    if (!userType) return <User className="w-4 h-4" />;
    switch (userType) {
        case 'admin':
            return <Shield className="w-4 h-4" />;
        case 'seller':
            return <Users className="w-4 h-4" />;
        case 'customer':
            return <User className="w-4 h-4" />;
        default:
            return <User className="w-4 h-4" />;
    }
};
export const getSellerUserStatusIcon = (status: string) => {
    switch (status) {
        case 'pending':
            return <Clock className="w-4 h-4" />;
        case 'verified':
            return <CheckCircle className="w-4 h-4" />;
        case 'rejected':
            return <XCircle className="w-4 h-4" />;
        default:
            return <AlertTriangle  className="w-4 h-4" />;
    }
};